import { lazy } from 'react';

import { ReactWebComponent } from '@app/utils/web-components';

const RootProviders = lazy(() => import('@app/components/AppProviders'));

const AiProfileInfo = lazy(() => import('./AiProfileInfo').then((module) => ({ default: module.AiProfileInfo })));

class AiProfileInfoComponent extends ReactWebComponent {
    render() {
        return (
            <RootProviders>
                <AiProfileInfo />
            </RootProviders>
        );
    }
}

customElements.define('ai-profile-info', AiProfileInfoComponent);
